import {
	BaseMessageSignerWalletAdapter,
	WalletName,
	WalletReadyState,
} from '@solana/wallet-adapter-base';
import {
	PublicKey,
	Transaction,
	TransactionVersion,
	VersionedTransaction,
} from '@solana/web3.js';
import { Provider } from '@reown/appkit-adapter-solana/react';

export class AppKitAdapter extends BaseMessageSignerWalletAdapter {
	url = '';
	readyState: WalletReadyState = WalletReadyState.Installed;
	connecting = false;
	supportedTransactionVersions?: ReadonlySet<TransactionVersion>;

	private provider: Provider;

	public name = 'unset' as WalletName;
	public icon: any = undefined;
	public publicKey: PublicKey | null = null;

	private _connected = false;

	public get connected() {
		return this._connected;
	}

	public set connected(value) {
		this._connected = value;
	}

	public constructor(address: string, appKitProvider: Provider) {
		super();
		this.provider = appKitProvider;
		this.name = ('AppKit::' +
			(appKitProvider?.name ?? 'unknown')) as WalletName;
		this.publicKey = new PublicKey(address);
	}

	public async signTransaction<T extends Transaction | VersionedTransaction>(
		tx: T
	) {
		return this.provider.signTransaction(tx);
	}

	public async signAllTransactions<
		T extends Transaction | VersionedTransaction,
	>(txes: T[]) {
		return this.provider.signAllTransactions(txes);
	}

	public async signMessage(message: Uint8Array) {
		return this.provider.signMessage(message);
	}

	// Extra step required for this adapter:
	public connect = async () => {
		await this.provider.connect();
		this._connected = true;
		this.emit('connect', this.publicKey as PublicKey);
		return;
	};

	public disconnect = async () => {
		await this.provider.disconnect();
		this._connected = false;
		this.emit('disconnect');
		return;
	};
}
